import React from 'react';
import './Roadmap.scss'

import roadmapBackground from '../../Images/roadmapbg.png'

function Roadmap() {
  return (
      <div id='roadmap'>
        <div className='roadmapContainer'>
            {/* <div>
                <img className='roadmapBackground' src={roadmapBackground} alt="" />
            </div> */}
            
            <div className='timeText'>
                <h2 className='soonText'>COMING SOON</h2>
                <h3 className='countdownText'>20D / 17H / 29M / 03S</h3>
            </div>
        </div>

        <div>
            <h2>ROADMAP</h2>
            <p className='subTitle'>Here is what we have planned for this project.</p>
            <p className='subTitle2'>DOLOR SIT AMIT<span className='slashPadding'>/</span>DOLOR SIT AMIT</p>
        </div>
      </div>
  );
}

export default Roadmap;
